import React from "react";
import "./ListCheckBoxWrapper.scss";

export const ListCheckBoxWrapper: React.FC = ({ children }) => (
  <div className="list-checkbox-wrapper">{children}</div>
);
